module.exports = __webpack_public_path__ + "static/media/menos.9a9c5d1d.svg";